/**
 * The album check before ordering, desktop layout (CheckBookPanel.scss) : see shared.panels.AlbumCheckPanel.
 *
 * Shown by Main on "order" when hasIssues(), and first thing in the preview mode, whatever the report.
 */
fx.ns("desktop.common.panels", class CheckBookPanel extends shared.panels.AlbumCheckPanel {

});
